<div class="custom-overlay-container  {{ additionalClass }}">
    <div class="custom-overlay-body">
        <div class="custom-overlay-content" role="dialog">
            <ng-content select="#content"></ng-content>
        </div>
    </div>
</div>